import { useQuery } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'
import { authStorage } from '../../context/Auth0ProviderWithHistory'

const getRecentDeliveries = async (inputObj) => {
  const { project, parentPart } = inputObj.queryKey[1]
  const recentDeliveriesAPIPath = `${API_URL}/api/delivery/v1/recentDeliveries?parentPart=${parentPart.partNumber}&project=${project}`

  const res = await axios.get(recentDeliveriesAPIPath)

  return res.data
}

export function useRecentDeliveries(project, parentPart) {
  const options = {
    enabled: !!parentPart,
    ...rqDefaultOptions,
  }
  return useQuery(['recentDeliveries', { project, parentPart }], getRecentDeliveries, options)
}
